/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const WebhookEventType = zod
	.object({
		label: zod.string().describe('Human-readable label for the event type'),
		value: zod.string().describe('Event type identifier (e.g. case.created)')
	})
	.describe('A webhook-eligible event type');

export type WebhookEventType = zod.input<typeof WebhookEventType>;
export type WebhookEventTypeOutput = zod.output<typeof WebhookEventType>;
